import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fc13451c&scoped=true&lang=html&"
import script from "./seckillStoreList.js?vue&type=script&lang=js&"
export * from "./seckillStoreList.js?vue&type=script&lang=js&"
import style0 from "./seckillStoreList.styl?vue&type=style&index=0&id=fc13451c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc13451c",
  null
  
)

export default component.exports